// Copy of the small window (K2 = the PiP), transcribed from D_Desk.dc.html renderVals() (pip, STATUS, REM, LN.nudge,
// LN.perfect, C[].act, btn(...) labels and aria). Lines that also exist in shared/src/content/lines.ts (morning,
// streak, levelUp) come from there; D_Desk has the same words. `noPlan` (afternoon / evening) was added 11-04.
import type { CharId } from '@shared/types';

type PerCh<T> = Record<CharId, T>;

export const PIP = {
  /** What she does while she waits (D_Desk C[].act): "Margo · writing cue notes". */
  act: { sunny: 'writing jokes', margo: 'writing cue notes', arjun: 'cleaning the mural', tavo: 'keeping score' } as PerCh<string>,
  /** At a card's time (D_Desk REM). {time} '11:30 AM', {Task} the card title before ':'. */
  remind: {
    sunny: "{time}. {Task}. I'd do it for you, but I'm busy being hilarious.",
    margo: "{time}. That's your cue: {Task}.",
    arjun: "It's {time}. Time for {Task}. Slowly is fine.",
    tavo: '{time}! {Task} is up to bat!',
  } as PerCh<string>,
  /** The soft line after a long quiet stretch while working together, at most twice a session (D_Desk LN.nudge). */
  nudge: {
    sunny: ['Still here. Still funny. No pressure.', "I'll wait. I'm great at waiting. It's in my act."],
    margo: ["Still with you. Next line whenever you're ready.", "Holding. Same cue when you're back."],
    arjun: ["Slow is fine. I'm still here.", 'The swab can wait. So can I.'],
    tavo: ['Still in the booth with you. Take your time!', 'No rush, folks. Still a ballgame.'],
  } as PerCh<[string, string]>,
  /** Nothing planned yet, after the morning (decided 11-04; in the morning it is LINES.morning). Afternoon: still time
   *  for a short plan. Evening: no push, two ways out: one small thing tonight, or tomorrow (Later). */
  noPlan: {
    sunny: { afternoon: "Half the day's left. That's a whole set. What's on for the rest?", evening: 'Evening. One tiny thing tonight, or we save the material for tomorrow?' },
    margo: { afternoon: "Intermission's over. What's on for the second half of today?", evening: "Evening. A short show tonight, or we set tomorrow's running order?" },
    arjun: { afternoon: 'Good afternoon. Plenty of canvas left today. What should go on it?', evening: 'Good evening. One small stroke tonight, or we save it for tomorrow?' },
    tavo: { afternoon: "Afternoon game's on! Who's in the lineup for the rest of today?", evening: "Night game, folks! One quick inning, or we set tomorrow's lineup?" },
  } as PerCh<{ afternoon: string; evening: string }>,
  /** Every card of the day done (D_Desk LN.perfect; the phone's R uses LINES.perfect). */
  perfect: {
    sunny: 'Every card. All of them. I need to sit down. Proud of you. Gross.',
    margo: 'Every card you planned. Done. I wrote it in my notebook.',
    arjun: 'Every card today. I saved you the good chair.',
    tavo: 'Every single card! Perfect day! The crowd goes wild!',
  } as PerCh<string>,
  status: {
    work: '{n} is working', typing: '{n} is writing too', glance: '{n} looked up', nudge: '{n} is still here',
    idle: '{n} · {act}', remind: '{n} · it’s {time}', alldone: '{d} of {t} done today', done: 'Done{mins} · +{pts}',
    ask: '{n} is checking in',
  },
  label: { upNext: 'UP NEXT · {time}', now: 'NOW · {time}', noPlan: 'NO PLAN YET', allDone: 'ALL DONE TODAY' },
  title: { noPlan: 'Tell {n} what’s on today', allDone: 'Day {k} is lit' },
  btn: {
    tick: '✓', stuck: 'Stuck', start: 'Start', done: '✓ Done', startTogether: 'Start together', later: 'Later',
    plan: 'Plan with {n}', next: 'Next: {Task}', notNow: 'Not now', seeIt: 'See it', keep: 'Keep going',
  },
  aria: {
    window: '{n}, in a small window that stays on top',
    tick: 'Mark done: {title}', stuck: 'Stuck: {title}', startTogether: 'Start together: {title}', done: 'Done: {title}',
    next: 'Start the next card together: {title}', later: 'Later: remind me again in a bit', keep: 'Keep going on {title}',
    size: 'Size: {s}', room: "Back to {n}'s room", hideMac: 'Hide to the menu bar', hideWin: 'Hide to the tray',
    tuck: 'Tuck to the screen edge', untuck: "Bring {n}'s window back", timer: 'Working together for {t}',
  },
  /** Only when this window lost its sign-in (the main window shows the sign-in). */
  signedOut: 'Open Xiaoman to sign in.',
  open: 'Open Xiaoman',
};
